<template>
  <div class="split-section d-flex align-items-center flex-wrap">
    <div
      class="left-infosec d-flex align-items-center flex-wrap align-items-center justify-content-center text-center rsvp"
    >
      <div class="leftblock-wrap">
        <div class="user-image">
          <span class="user-bg"></span>
          <img
            :src="sharedEvent.image!=='undefined'?sharedEvent.image:'/img/defaultUser.8f379dba.png'"
            class="host-image"
            alt="image description"
            style="background-color: #f6cfe1;"
          />
          <!-- <img :src="sharedEvent.image"> -->
        </div>
        <div class="info-detail">
          <h2>
            {{sharedEvent.hostName}} has
            <br />invited you to
            <br />
            {{sharedEvent.eventName}}
          </h2>
        </div>
        <a
          data-toggle="modal"
          @click="acceptInvitation"
          data-target="#create"
          href="#"
          class="btn btn-primary"
          style="margin:4px;"
        >Accept</a>
        <a
          data-toggle="modal"
          @click="rejectInvitation"
          data-target="#create"
          href="#"
          style="margin:4px;"
          class="btn btn-primary"
        >Reject</a>
      </div>
    </div>
  </div>
</template>
<script>
import { ACCEPT_REJECT_WISHLIST } from "../store/wishlist/action.type";

export default {
  data() {
    return {
      sharedEventId: false,
      sharedEvent: {}
    };
  },
  created() {
    this.sharedEventId = localStorage.getItem("sharedEventId");
    this.sharedEvent = JSON.parse(localStorage.getItem("sharedEvent"));
  },
  methods: {
    acceptInvitation(e) {
      e.preventDefault();
      const body = {
        wishlistId: this.sharedEventId,
        status: true
      };
      this.acceptRejectWishlistInvitation(body);
    },
    rejectInvitation(e) {
      e.preventDefault(e);
      const body = {
        wishlistId: this.sharedEventId,
        status: false
      };
      this.acceptRejectWishlistInvitation(body);
    },

    acceptRejectWishlistInvitation(body) {
      this.$store.dispatch(ACCEPT_REJECT_WISHLIST, body).then(response => {
        localStorage.removeItem("sharedEvent");
        localStorage.removeItem("sharedEventId");
        if (response.status == 200) {
          console.log(response);
          this.apiSuccessMessage = response.data.message;
          this.apiErrorMessage = null;
          if (body.status) {
            return this.$router.push({
              path: "/wishlist/" + this.sharedEventId
            });
          } else {
            return this.$router.push({ path: "/dashboard" });
          }
        } else {
          this.apiErrorMessage = response.data.message;
          this.apiSuccessMessage = null;
        }
      });
    }
  }
};
</script>
<style scoped>
.user-image img {
  object-fit: cover;
  object-position: cover;
}
</style>